import React, { useEffect, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import ReactHTML from 'components/shared/ReactHtml';
import trackEvent from 'misc/trackEvent';
import { Button } from 'ui';
import RevealImage from './RevealImage';
import { RevealTypes } from './types';

const Reveal = ({
  alt_content_image_url: altContentImageUrl,
  body,
  content_image_url: contentImageUrl,
  instruction,
  reveal_id: revealId,
  subject,
}) => {
  const [isShown, setIsShown] = useState(false);

  useEffect(() => {
    if (isShown) {
      trackEvent('reveal_revealed', { reveal_id: revealId }, false);
    }
  }, [isShown, revealId]);

  return (
    <>
      <div className="RevealElement-subject">
        {!!contentImageUrl && <RevealImage imageUrl={contentImageUrl} />}
        <ReactHTML THE_DATA_HAS_BEEN_SANITIZED>{subject}</ReactHTML>
        {!!instruction && (
          <div className="RevealElement-instruction">
            <ReactHTML THE_DATA_HAS_BEEN_SANITIZED>{instruction}</ReactHTML>
          </div>
        )}
      </div>
      <CSSTransition
        appear
        classNames="RevealElement-body"
        in={isShown}
        timeout={500}
      >
        <div className="RevealElement-body">
          {!!altContentImageUrl && (
            <RevealImage imageUrl={altContentImageUrl} />
          )}
          <ReactHTML THE_DATA_HAS_BEEN_SANITIZED>{body}</ReactHTML>
        </div>
      </CSSTransition>
      <Button
        icon={isShown ? 'chevron-up' : 'chevron-down'}
        className="RevealElement-button"
        onClick={() => {
          setIsShown(!isShown);
        }}
      >
        {isShown ? t('interactive.hide') : t('interactive.reveal')}
      </Button>
    </>
  );
};

Reveal.propTypes = RevealTypes;

export default Reveal;
